import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

export const getSubservices = createAsyncThunk('users/getSubservices', async (locationId, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/location/${locationId}/subservices`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});
